import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Images from '../../media/icon.png';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class View extends Component {

  state= {
    file: null,
    load: false,
  }

  handleFile = e => {
    this.updateLocalfile(e.target.files[0]);
    this.updateImageData(e.target.files[0])
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  updateImageData(file) {
    let context = this;
    let partCode = this.props.partCode;
    let oldImage = this.props.image_name;
    var formData = new FormData();
    formData.append('partCode', partCode);
    formData.append('file', file);
    formData.append('oldImage', oldImage);

    context.setState({
      load: true,
      message: 'Updating Spares Images!!!'
    });
    $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'spares/updateimages.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
      },
      error: function(error) {
        context.setState({
          load: false,
        });
      }
    });
  }

  render() {
    let { load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
      { this.state.file ?
        (
          <div>
            <input id={this.props.image} type="file" onChange={this.handleFile} style={{display: 'none'}}/>
            <label htmlFor={this.props.image}>
              <Image src={this.state.file} size='small'
              style={{borderStyle: 'solid', borderWidth: 1, cursor: 'pointer', height: 100}}
              id='image' />
            </label>
          </div>
        ) :
        (
          <div>
            <input id={this.props.image} type="file" onChange={this.handleFile} style={{display: 'none'}}/>
            <label htmlFor={this.props.image}>
              <Image src={this.props.image} size='small'
              style={{borderStyle: 'solid', borderWidth: 1, cursor: 'pointer', height: 100}}
              id='image' />
            </label>
          </div>
        )
      }
      {loading}
      </div>
    );
  }
}

export default View;
